if (!customElements.get('bcb-buying-tools')) {
  customElements.define('bcb-buying-tools', class extends HTMLElement {
    connectedCallback() {
      this.root = document.getElementById(`MainProduct-${this.dataset.section}`);
      if (!this.root) return;
      this.settings = JSON.parse(this.querySelector('[data-buying-settings]').textContent);
      this.readyToBuy = this.dataset.preselected === 'true' || !this.root.querySelector('variant-selects');
      this.frame = null;
      this.schedule = () => { if (this.frame === null) this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); }); };
      this.onChange = event => {
        if (event.target.closest('variant-selects')) this.readyToBuy = true;
        this.schedule();
      };
      this.onAdd = () => {
        this.root = document.getElementById(`MainProduct-${this.dataset.section}`) || this.root;
        const button = this.root.querySelector('button[name="add"]');
        if (!this.readyToBuy) {
          const picker = this.root.querySelector('variant-selects');
          picker?.scrollIntoView({behavior:'instant', block:'center'});
          picker?.querySelector('input:checked, select')?.focus({preventScroll:true});
          return;
        }
        if (button && !button.disabled && button.getAttribute('aria-disabled') !== 'true') button.click();
      };
      this.root.addEventListener('change', this.onChange);
      this.root.addEventListener('input', this.schedule);
      this.querySelector('[data-mobile-add]').addEventListener('click', this.onAdd);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.root,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled']});
      this.sync();
    }
    sync() {
      this.root.querySelectorAll('lb-upsell-product-page-addon').forEach(addon => {
        if (addon.closest('.bcb-addons')) return;
        const details = document.createElement('details');
        details.className = 'bcb-addons';
        if (this.dataset.tv === 'true') details.open = true;
        const summary = document.createElement('summary');
        summary.textContent = this.settings.addons;
        details.append(summary);
        addon.before(details);
        details.append(addon);
      });
      const mainButton = this.root.querySelector('button[name="add"]');
      const mobileButton = this.querySelector('[data-mobile-add]');
      let variant = null;
      try { variant = JSON.parse(this.root.querySelector('variant-selects [data-selected-variant]')?.textContent || 'null'); } catch {}
      const priceNode = this.root.querySelector('.price:not(.hidden) .price-item--sale') && this.root.querySelector('.price--on-sale')
        ? this.root.querySelector('.price--on-sale .price-item--sale')
        : this.root.querySelector('.price .price__regular .price-item--regular');
      const price = this.querySelector('[data-mobile-price]');
      const nextPrice = priceNode?.textContent.trim() || '';
      if (price.textContent !== nextPrice) price.textContent = nextPrice;
      const label = this.querySelector('[data-mobile-variant]');
      const nextLabel = variant?.title || this.root.querySelector('h1')?.textContent.trim() || '';
      if (label.textContent !== nextLabel) label.textContent = nextLabel;
      mobileButton.disabled = !mainButton || mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
      const buttonLabel = this.readyToBuy ? (mainButton?.querySelector('span')?.textContent.trim() || this.settings.add) : this.settings.choose;
      if (mobileButton.textContent !== buttonLabel) mobileButton.textContent = buttonLabel;
      const summary = this.root.querySelector('[data-bcb-pack-summary]');
      if (summary && variant && this.settings.packIndex >= 0) {
        const boxes = Number.parseInt(variant.options[this.settings.packIndex],10);
        const packs = Number.parseInt(this.root.querySelector('.quantity__input')?.value || '1',10);
        const message = Number.isFinite(boxes) && Number.isFinite(packs) ? this.settings.packSummary.replace('[packs]',packs).replace('[boxes]',boxes).replace('[total]',packs*boxes) : '';
        if (summary.textContent !== message) summary.textContent = message;
      }
      const fit = this.root.querySelector('[data-bcb-fit]');
      const dims = {'24':'560 × 170 × 380','32':'895 × 150 × 565','36':'1000 × 150 × 600','43':'1100 × 150 × 725','48':'1200 × 180 × 820','55':'1320 × 180 × 880','70':'1680 × 130 × 1060'};
      if (fit && variant && this.dataset.tv === 'true') {
        const size = Number.parseInt(variant.options[0],10);
        const message = dims[size] ? this.settings.fit.replace('[size]',size).replace('[dimensions]',dims[size]) : '';
        if (fit.textContent !== message) fit.textContent = message;
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.root?.removeEventListener('change',this.onChange);
      this.root?.removeEventListener('input',this.schedule);
      if (this.frame !== null) cancelAnimationFrame(this.frame);
    }
  });
}
